/**
 * Cart Variant Selector
 * Allows users to change product variant (size) directly in cart
 */

(function() {
  'use strict';

  function initCartVariantSelector() {
    const allSelectors = document.querySelectorAll('.cart-variant-selector');

    if (allSelectors.length === 0) {
      return;
    }

    allSelectors.forEach(function(select) {
      // Remove any existing listeners to avoid duplicates
      const newSelect = select.cloneNode(true);
      select.parentNode.replaceChild(newSelect, select);

      newSelect.addEventListener('change', function(e) {
        const newVariantId = e.target.value;
        const line = newSelect.dataset.line;
        const currentVariantId = newSelect.dataset.currentVariant;
        const quantity = newSelect.dataset.quantity;
        const itemKey = newSelect.dataset.key;

        // Validation checks
        if (!newVariantId || !line || !quantity || parseInt(quantity) <= 0) {
          newSelect.value = currentVariantId;
          return;
        }

        if (newVariantId === currentVariantId) {
          return;
        }

        // Convert to appropriate types
        const newVariantIdNum = parseInt(newVariantId);
        const lineNum = parseInt(line);
        const quantityNum = parseInt(quantity);

        // Disable select during operation
        newSelect.disabled = true;

        // Remove old variant
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            line: lineNum,
            quantity: 0
          })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to remove variant: ' + response.status);
          }
          return response.json();
        })
        .then(() => {
          // Add new variant with preserved quantity
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: newVariantIdNum,
              quantity: quantityNum
            })
          });
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to add variant: ' + response.status);
          }
          return response.json();
        })
        .then(data => {
          // Get the new item key from the add response (key changes when variant changes)
          const newItemKey = data.key;

          // Refresh cart
          const isMainCart = document.querySelector('cart-items') !== null;
          const isSideCart = document.querySelector('.js-menu__context') !== null;

          if (isMainCart) {
            // For main cart, use page reload
            window.location.reload();
            return;
          } else if (isSideCart) {
            // For side cart, use refreshCart and re-initialize
            const container = document.querySelector('.js-menu__context');

            if (container && typeof refreshCart === 'function') {
              refreshCart();
              setTimeout(() => {
                initCartVariantSelector();
                // Update the select value to match the new variant
                const newSelects = container.querySelectorAll('.cart-variant-selector');
                newSelects.forEach(s => {
                  if (s.dataset.key === newItemKey) {
                    s.value = String(newVariantIdNum);
                    s.disabled = false;
                  }
                });
              }, 500);
            } else {
              // Fallback: reload page
              window.location.reload();
            }
          } else {
            // Fallback: reload page
            window.location.reload();
          }
        })
        .catch(error => {
          // Re-enable select on error
          newSelect.disabled = false;
          // Reset to original value
          newSelect.value = currentVariantId;
        });
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartVariantSelector);
  } else {
    initCartVariantSelector();
  }

  // Re-initialize when side cart content changes (using MutationObserver)
  const sideCartContainer = document.querySelector('.js-menu__context');
  if (sideCartContainer) {
    const sideCartObserver = new MutationObserver((mutations) => {
      let shouldReinit = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('.cart-variant-selector')) {
            shouldReinit = true;
          }
        });
      });
      if (shouldReinit) {
        setTimeout(initCartVariantSelector, 100);
      }
    });

    sideCartObserver.observe(sideCartContainer, {
      childList: true,
      subtree: true
    });
  }
})();